




























































































import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import moment from "moment";

@Component({
  components: {},
})
export default class RiwayatSkriningRisikoJatuh extends Vue {
  @Prop() riwayatSkrining!: string;
  // get stateRiwayatRisikoJatuh() {
  //   return storeAssesmenRisikoJatuh.riwayatRisikoJatuh;
  // }

  getHumanDate(date) {
    return date ? moment(date, "YYYY-MM-DD").format("DD MMMM YYYY") : "";
  }
}
